import clsx from 'clsx';
import * as React from 'react';
import { StyledSkeleton } from './Skeleton.styles';
import { jsx as _jsx } from "react/jsx-runtime";
const defaultElement = 'div';
function Skeleton(props, ref) {
  const {
    // appearance
    as = defaultElement,
    variant = 'rect',
    width = '100%',
    height = 8,
    className,
    ...htmlAttributes
  } = props;
  return /*#__PURE__*/_jsx(StyledSkeleton, {
    className: clsx('ovpn-skeleton', className),
    forwardedAs: as,
    variant: variant,
    $height: height,
    $width: width,
    ref: ref,
    ...htmlAttributes
  });
}
export default /*#__PURE__*/React.forwardRef(Skeleton);